/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetYoutubePlaylistsQueryResponse, SocialExportGetYoutubePlaylistsPathParams, SocialExportGetYoutubePlaylists400, SocialExportGetYoutubePlaylists401, SocialExportGetYoutubePlaylists403, SocialExportGetYoutubePlaylists404 } from "../models/SocialExportGetYoutubePlaylists";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetYoutubePlaylists } from "../axios/socialExportGetYoutubePlaylists";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetYoutubePlaylistsQueryKey = (connectionId: SocialExportGetYoutubePlaylistsPathParams["connectionId"]) => ["api-v2", { url: '/social-export/v1/platforms/youtube/:connectionId/playlists', params: {connectionId:connectionId} }] as const

export type SocialExportGetYoutubePlaylistsQueryKey = ReturnType<typeof socialExportGetYoutubePlaylistsQueryKey>

export function socialExportGetYoutubePlaylistsQueryOptions(connectionId: SocialExportGetYoutubePlaylistsPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetYoutubePlaylistsQueryKey(connectionId)
        return queryOptions<SocialExportGetYoutubePlaylistsQueryResponse, ResponseErrorConfig<SocialExportGetYoutubePlaylists400 | SocialExportGetYoutubePlaylists401 | SocialExportGetYoutubePlaylists403 | SocialExportGetYoutubePlaylists404>, SocialExportGetYoutubePlaylistsQueryResponse, typeof queryKey>({
         enabled: !!(connectionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetYoutubePlaylists(connectionId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all playlists owned by the authenticated YouTube user for the connection (may use cache).
 * @summary Get YouTube playlists for a connection
 * {@link /social-export/v1/platforms/youtube/:connectionId/playlists}
 */
export function useSocialExportGetYoutubePlaylists<TData = SocialExportGetYoutubePlaylistsQueryResponse, TQueryData = SocialExportGetYoutubePlaylistsQueryResponse, TQueryKey extends QueryKey = SocialExportGetYoutubePlaylistsQueryKey>(connectionId: SocialExportGetYoutubePlaylistsPathParams["connectionId"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetYoutubePlaylistsQueryResponse, ResponseErrorConfig<SocialExportGetYoutubePlaylists400 | SocialExportGetYoutubePlaylists401 | SocialExportGetYoutubePlaylists403 | SocialExportGetYoutubePlaylists404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetYoutubePlaylistsQueryKey(connectionId)
         

         const query = useQuery({
          ...socialExportGetYoutubePlaylistsQueryOptions(connectionId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetYoutubePlaylists400 | SocialExportGetYoutubePlaylists401 | SocialExportGetYoutubePlaylists403 | SocialExportGetYoutubePlaylists404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}